<template>
  <div>    
    <base-title :title="StringLanguage.socialNetworks" :subtitle="StringLanguage.configurations" :link="'configuracoes'"/>

    <base-box>
      <base-label text="Informe as redes da sua loja" class="mb_30"/>

      <base-input :label="'Website'" v-model="social.website"/>
      <base-input :label="'Facebook'" v-model="social.facebook"/>
      <base-input :label="'Instagram'" v-model="social.instagram"/>
      <base-input :label="'Youtube'" v-model="social.youtube"/>
      <base-input :label="'Pinterest'" v-model="social.pinterest"/>
      <base-input :label="'Twitter'" v-model="social.twitter"/>
    </base-box>

    <!-- <div class="d-flex justify-end w-100">
      <base-button :text="'Salvar'" @click="save"/>
    </div> -->
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import Social from "@/plugins/core/schema/configurations/BasicInfo/Social"
import StoreAPI from '@/api/store'
import Vue from 'vue'

import BaseTitle from '@/components/Title'
import BaseButton from '@/components/Button'
import BaseBox from '@/components/Box'
import BaseInput from '@/components/Input'
import BaseLabel from '@/components/Label'

export default {
  data() {
    return { 
      social: new Social(),
      originalData: null
    }
  },
  beforeDestroy () {
    if(JSON.stringify(this.originalData) != JSON.stringify(this.social)) {
      this.save();
    } 
  },
  created() {
    let self = this;
    StoreAPI.storeGetConfiguration('social').then((response) => {
      self.set(response)
    })
  },
  methods: {
    set(response) {
      if(response.getErrors([]).length > 0) {
          return false
      } else {
        if(response.getData({}).social || false) {
            let social = response.getData(new Social).social;
            Vue.set(this, 'social', new Social(
              social.website,
              social.facebook,
              social.instagram,
              social.youtube,
              social.pinterest,
              social.twitter,
            ));
            Vue.set(this, 'originalData', new Social(
              social.website,
              social.facebook,
              social.instagram,
              social.youtube,
              social.pinterest,
              social.twitter,
            ));
        } else {
          Vue.set(this, 'social', new Social());
          Vue.set(this, 'originalData', new Social());
        }
      }
    },
    save() {
      let self = this
      StoreAPI.storeConfiguration({
        'social': this.social
      }).then((response) => {
        this.$store.dispatch('store/getConfigurations')
        self.set(response)
      })
    }
  },
  components: {
    TheMask,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseLabel,
  }
}
</script>